import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';
require('moment');

    export default GenericModel.extend({
        url : '/CampaignCloud/Notifications',
        idAttribute : 'id',
        parse : function (model) {
            return JSON.parse(model);
        }
    });
